import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import AppStrings from '../../config/appstring';
import { useLocation } from 'react-router-dom';

const BonafidePrint = ({ RefNo, onClose }) => {
  const location = useLocation();

  const [feeDetails, setFeeDetails] = useState([]);
  const [totalAmt, setTotalAmt] = useState(0);
  const [Header1, setHeader1] = useState('');
  const [Header2, setHeader2] = useState('');
  const [STUDENTNAME, setStudentName] = useState('');
  const [VoucherNo, setVoucherNo] = useState('');
  const [TYPE, setTYPE] = useState('');
  const [EntDate, setEntDate] = useState('');
  const [className, setclassName] = useState('');
  const [AdmissionID, setAdmissionID] = useState('');
  const [PICKUPPLACE, setPICKUPPLACE] = useState('');
  const [Total, setTotal] = useState('');
  const [Paid, setPaid] = useState('');
  const [BALANCE, setBALANCE] = useState('');
  const [SchoolPay, setSchoolPay] = useState('');
  const [BusPay, setBusPay] = useState('');
  const [UserName, setUserName] = useState('');

  const tableRef = useRef();

  // ✅ Define image list and active image before usage
  const imageList = [
    {
      ID: 1,
      PATH: "https://schoolmanagement.agnisofterp.com/bonafide_certificate/3d glass window logo mockup.jpg",
      ACTIVE: "Y"
    },
    {
      ID: 2,
      PATH: "https://schoolmanagement.agnisofterp.com/bonafide_certificate/Picture1.png",
      ACTIVE: "N"
    }
  ];

const [items, setItems] = useState([]);
    const fetchReportList = () => {
  axios.get(AppStrings.BonafideImageList)
    .then((response) => {
      console.log(response.data.data, 'list');
      setItems(response.data.data);
    })
    .catch((error) => {
      console.error('Error fetching items:', error);
    });
};
  const activeImage = items.find(img => img.ACTIVE === 'Y');
  const encodedPath = activeImage ? encodeURI(activeImage.PATH) : '';

  const academicFees = feeDetails.filter(fee => fee.FEESTYPE === 'ACADEMIC');
  const transportFees = feeDetails.filter(fee => fee.FEESTYPE === 'TRANSPORT');

  //console.log(activeImage,'sssssss')

  useEffect(() => {
    fetchReportList();
    const fetchFeeDetails = async () => {
      const url = AppStrings.BillPrint + `?REFNO=${RefNo || '2425SCISM2432'}`;
      try {
        const response = await axios.get(url);
        const data = response.data.data?.[0];
        const result = data?.result || data?.LIST || [];

        setTotalAmt(data?.TOTAL || 0);
        setHeader1(data?.COMPANYDETAIL?.[0]?.DATA1 || '');
        setHeader2(data?.COMPANYDETAIL?.[0]?.DATA2 || '');
        setStudentName(data?.STUDENTNAME || '');
        setVoucherNo(data?.SCHOOL_VOUNO || data?.BUS_VOUNO || '');
        setTYPE(data?.TYPE || '');
        setEntDate(data?.SCHOOL_DATE || data?.BUS_DATE || '');
        setclassName(data?.CLASS || '');
        setAdmissionID(data?.STUDENTID || '');
        setPICKUPPLACE(data?.PICKUPPLACE || '');
        setTotal(data?.TOTAL || 0);
        setPaid(data?.PAID || 0);
        setBALANCE(data?.BALANCE || 0);
        setSchoolPay(data?.SCHOOL_FEESAPPLIED || 0);
        setBusPay(data?.BUS_FEESAPPLIED || 0);
        setUserName(data?.USERNAME || '');

        if (Array.isArray(result)) {
          const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
          setFeeDetails(withEditable);
        } else {
          alert("No fee records found.");
        }
      } catch (error) {
        console.error("Error fetching fee details:", error);
        alert("Failed to fetch fee details.");
      }
    };

    fetchFeeDetails();
  }, [RefNo]);

const handlePrint = () => {
  const printContents = tableRef.current.innerHTML;
  const printWindow = window.open('', '_blank', 'width=900,height=650');

  const logoSrc = TYPE === 'CBSE'
    ? 'https://schoolmanagement.agnisofterp.com/image/cbse_logo.jpeg'
    : 'https://schoolmanagement.agnisofterp.com/image/school_logo.png';

  printWindow.document.write(`
    <html>
      <head>
        <link href="https://fonts.googleapis.com/css2?family=Maragsa+Serif&display=swap" rel="stylesheet">
        <style>
          @media print {
            @page {
              size: A4;
              margin: 0;
            }

            body {
              width: 210mm;
              height: 297mm;
              margin: 0;
              font-family: 'Maragsa Serif', serif;
              background: url('${encodedPath || ''}') no-repeat center center;
              background-size: cover;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }

            .print-container {
              padding: 20mm;
              box-sizing: border-box;
            }

            .headerrow {
              display: flex;
              justify-content: space-between;
              margin-bottom: 10px;
              background-color: transparent;
              text-align: center;
            }

            .logoStyle {
              width: 20%;
              height: 100px;
              box-sizing: border-box;
            }

            .addressStyle {
              width: 80%;
              height: 100px;
              box-sizing: border-box;
            }

            .CompNameHeader {
              font-size: 30px;
              font-weight: bold;
            }

             .CompNameHeader1 {
              font-size: 20px;
            }

            .StudentheaderBoxStyleName,.StudentheaderBoxStyleClass,.StudentheaderBoxStyleParentName,.StudentheaderBoxStyleYear   {
              height: 45px;
              font-size: 20px;
              box-sizing: border-box;
              margin: 295px 0px 0px 220px;
            }

            .StudentheaderBoxStyleParentName {
            
              margin: 10px 0px 0px 180px;
            }

            .StudentheaderBoxStyleClass {
             
              margin: 5px 0px 0px 530px;
            }

            .StudentheaderBoxStyleYear {
             
              margin: 0px 0px 0px 220px;
            }
          }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        <div class="print-container">
          <div class="headerrow">
            <div class="logoStyle">
              <img src="${logoSrc}" alt="Logo" style="width: 100%; height: 100%; object-fit: contain;" />
            </div>
            <div class="addressStyle">
              <div class="CompNameHeader">${Header1}</div>
              <div class="CompNameHeader1">${Header2}</div>
            </div>
          </div>

          <div class="StudentheaderBoxStyleName">${STUDENTNAME}</div>
          <div class="StudentheaderBoxStyleParentName">ParentName ${className}</div>
          <div class="StudentheaderBoxStyleClass">${className}</div>
          <div class="StudentheaderBoxStyleYear">2025-2026</div>
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();
};


{/* <body onload="window.print(); window.close();">
        <div class="print-container">
          ${printContents}
        </div>
      </body> */}

  // 💡 Styles
  

  const headerrow = {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
    backgroundColor:'transparent',
    textAlign:'center'
  };

  const headerBoxStyle = {
    width: '25%',
    height: '100px',
    boxSizing: 'border-box'
  };

  const StudentheaderBoxStyleName = {
    height: '45px',
    fontSize: '15px',
    boxSizing: 'border-box',
    margin:'135px 0px 0px 140px'
  };

   const StudentheaderBoxStyleParentName = {
    height: '45px',
    fontSize: '15px',
    boxSizing: 'border-box',
    margin:'-14px 0px 0px 140px'
  };

    const StudentheaderBoxStyleClass = {
    height: '45px',
    fontSize: '15px',
    boxSizing: 'border-box',
    margin:'-13px 0px 0px 330px'
  };

  const StudentheaderBoxStyleYear = {
    height: '45px',
    fontSize: '15px',
    boxSizing: 'border-box',
    margin:'-17px 0px 0px 200px'
  };

  const CompNameHeader = {
    fontSize: '20px',
    fontWeight: 'bold'
  };

  const logoStyle = {
    ...headerBoxStyle,
    width: '20%'
  };

  const addressStyle = {
    ...headerBoxStyle,
    width: '80%'
  };

  const A4Sheet = {
    width: 'auto',
    height: '90vh',
    aspectRatio: '210 / 297',
    backgroundImage: encodedPath ? `url("${encodedPath}")` : 'none',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
    padding: '2rem',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    overflow: 'auto',
    borderRadius: '8px',
    fontFamily: '"Maragsa Serif", serif'
  };

  return (
    <div>
      <div ref={tableRef} style={A4Sheet}>
        <div style={headerrow}>
          <div style={logoStyle}>
            <img
              src={TYPE === 'CBSE'
                ? 'https://schoolmanagement.agnisofterp.com/image/cbse_logo.jpeg'
                : 'https://schoolmanagement.agnisofterp.com/image/school_logo.png'}
              alt="Logo"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </div>
          <div style={addressStyle}>
            <div style={CompNameHeader}>{Header1}</div>
            <div>{Header2}</div>
          </div>
        </div>
 <div style={StudentheaderBoxStyleName}>{STUDENTNAME}</div>
 <div style={StudentheaderBoxStyleParentName}>ParentName{className}</div>
 <div style={StudentheaderBoxStyleClass}>{className}</div>
 <div style={StudentheaderBoxStyleYear}>2025-2026</div>
        {/* <div style={headerrow}>
          <div style={StudentheaderBoxStyle}><strong>Name:</strong><br />{STUDENTNAME}</div>
          <div style={StudentheaderBoxStyle}><strong>Class:</strong><br />{className}</div>
          <div style={StudentheaderBoxStyle}><strong>Admission ID:</strong><br />{AdmissionID}</div>
          <div style={StudentheaderBoxStyle}><strong>Vou No - Date:</strong><br />{VoucherNo} - {EntDate}</div>
        </div> */}

      
       
      </div>

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button
          onClick={handlePrint}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            marginRight: '10px',
            cursor: 'pointer'
          }}
        >
          🖨️ Print
        </button>
        <button
          onClick={onClose}
          style={{
            padding: '10px 20px',
            backgroundColor: '#6c757d',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default BonafidePrint;
